import { Component, input } from '@angular/core';
import { TabLayoutComponent } from "../../../../../components/tab-layout/tab-layout.component";
import { TabComponent } from '../../../../../components/tab/tab.component';
import { RadarChart, RadarChartComponent } from '../../../../../components/radar-chart/radar-chart.component';

@Component({
  selector: 'app-rep-evaluation-tab',
  imports: [TabLayoutComponent, RadarChartComponent],
  providers: [{ provide: TabComponent, useExisting: RepEvaluationTabComponent }],
  templateUrl: './rep-evaluation-tab.component.html',
  styleUrl: './rep-evaluation-tab.component.scss'
})
export class RepEvaluationTabComponent extends TabComponent {
  repData = input.required<{ date: string, data: RadarChart }>();

  override async main(): Promise<void> {
    this.name = this.repData().date;
  }

}
